import React, { useState, useEffect } from 'react';
import CandidateService from './CandidateService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './candidateJsonSchema';
import AdvanceList from '../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
const CandidateList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const fieldsForList = [{
          accessor: 'firstName',
          Header: 'Candidate',
          headerProps: { className: 'pe-1' },
          cellProps: {
            className: 'py-2'
          },
          Cell: rowData => {
            const { firstName, lastName, identifier } =
              rowData.row.original;
            const link =
              '/app/candidates/' + identifier + '/edit';
            return (
              <Link to={link}>
                <Flex alignItems="center">
                  <div className="flex-1">
                    <h5 className="mb-0 fs--1">{firstName + ' ' + lastName}</h5>
                  </div>
                </Flex>
              </Link>
            );
          }
        },
        { accessor: 'email', Header: 'Email' }
      ];

      setColumns(fieldsForList);

      CandidateService.retrieveAllCandidateByAccount()
        .then(data => {
          setData(data);
          setNoDataToShow(!data.length > 0);
        })
        .catch(error => setError({ error: error.message }));
    };
    fetchData();
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'New Candidate',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Create a new Candidate');
        navigate('/app/candidates/create-form');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Create Candidate',
    ' ',
    buttonsConf
  );
  return (
    <>
      {headerGenerated}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Candidate to show. Let's create a new one!
        </Alert>
      )}
      {data && !noDataToShow && <AdvanceList columns={columns} data={data} />}
    </>
  );
};

export default CandidateList;
